import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { Color, Tile, TILE_TOKEN, TileId, TileType } from '@contact/upgrade';

import { HistoryCoreForRootModule } from './core/history-core-for-root.module';

@NgModule({
  imports: [HistoryCoreForRootModule.instance()],
})
export class HistoryForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: HistoryForRootModule) {
    if (parentModule) throw new Error(`[HistoryForRootModule] module is already loaded`);
  }

  static instance(options: { path: string }): ModuleWithProviders<HistoryForRootModule> {
    return {
      ngModule: HistoryForRootModule,
      providers: [
        {
          provide: TILE_TOKEN,
          useValue: {
            id: TileId.HISTORIZATION,
            type: TileType.STANDARD,
            icon: 'tile_history',
            color: Color.BLUE,
            platforms: {
              desktop: {
                path: options.path,
              },
            },
            activePlatform: 'desktop',
          } as Tile,
          multi: true,
        },
      ],
    };
  }
}
